import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import { isSpacePressed, isEnterPressed } from 'app/utils/accessibility/accessibilityUtils';
import './product-list_sort-dropdown.scss';

const {
  advancedCommerce: { isListingPage },
} = window.inlineGlobalConfig;

const SortDropdown = ({ sortFields, onSortSelect, selectedSort, idSuffix, additionalClass }) => {
  const intl = useIntl();
  const selectedItem = sortFields.find(item => item.code === selectedSort) || {};
  const [dropdownOpen, setDropdownOpen] = useState(false);

  return (
    sortFields.length !== 0 && (
      <div className={`product-list__sort-dropdown-container ${additionalClass}`}>
        <div className="product-list__sort-dropdown-container--select">
          <select
            aria-label={intl.formatMessage({
              id: 'products.productgrid.sortBy',
            })}
            className={`hide-for-large-up ${selectedSort} ellipsis`}
            name="sort-by"
            id={`sort-by${idSuffix}`}
            onChange={event => {
              onSortSelect(event.target.value);
            }}
            defaultValue={selectedSort || 'sortBy'}
          >
            <FormattedMessage id="products.productgrid.sortBy">
              {message => (
                <option value="sortBy" disabled hidden>
                  {message}
                </option>
              )}
            </FormattedMessage>
            {sortFields.map(optionItem => (
              <option key={optionItem.code} value={optionItem.code}>
                {isListingPage ? (
                  <FormattedMessage id={`${optionItem.name}`} description="sort option" />
                ) : (
                  optionItem.name
                )}
              </option>
            ))}
          </select>

          <div
            className="product-list__sort-dropdown-container--icon"
            style={{ display: idSuffix ? 'inherit' : 'none' }}
          >
            <i className="fa-regular fa-chevron-down" />
          </div>
          <div className={`custom-sort-dropdown ${dropdownOpen ? 'hover' : ''}`}>
            <button
              type="button"
              className="custom-sort-dropdown__btn ellipsis"
              onKeyDown={e => {
                if (isSpacePressed(e)) {
                  setDropdownOpen(!dropdownOpen);
                }
              }}
            >
              {selectedItem.name ? (
                <>
                  <span className="sortby-selected-label">
                    {isListingPage ? (
                      <FormattedMessage id={`${selectedItem.name}`} description="sort option" />
                    ) : (
                      selectedItem.name
                    )}
                  </span>
                  <i className="fa-regular fa-chevron-down" />
                </>
              ) : (
                <>
                  <span className="sortby-selected-label">
                    <FormattedMessage id="products.productgrid.sortBy" tagName="span" />
                  </span>
                  <i className="fa-regular fa-chevron-down" />
                </>
              )}
            </button>
            <div className="custom-sort-dropdown__list" role="listbox">
              {sortFields.map(optionItem => (
                <div
                  tabIndex="0"
                  onClick={e => {
                    e.currentTarget.blur();
                    onSortSelect(optionItem.code);
                    setDropdownOpen(false);
                  }}
                  onKeyDown={e => {
                    if (isEnterPressed(e) || isSpacePressed(e)) {
                      e.currentTarget.blur();
                      onSortSelect(optionItem.code);
                      setDropdownOpen(false);
                    }
                  }}
                  role="option"
                  aria-selected={optionItem.code === selectedSort}
                  key={`listbox-${optionItem.code}`}
                  id={`listbox-${optionItem.code}${idSuffix}`}
                  className={`custom-sort-dropdown__list-item ${optionItem.code === selectedSort ? 'is-selected' : ''}`}
                >
                  {isListingPage ? (
                    <FormattedMessage id={`${optionItem.name}`} description="sort option" />
                  ) : (
                    optionItem.name
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    )
  );
};

SortDropdown.defaultProps = {
  idSuffix: '',
  selectedSort: '',
  additionalClass: '',
};

SortDropdown.propTypes = {
  onSortSelect: PropTypes.func.isRequired,
  selectedSort: PropTypes.string,
  idSuffix: PropTypes.string,
  additionalClass: PropTypes.string,
};

export default SortDropdown;
